/* Copyright 2013 - 2022 Waiterio LLC */
export default '#5cb85c'
